import styled from "styled-components";

export const inputStyle = {
    width: "calc(100% - 46px)",
    borderStartEndRadius: "6px",
    borderEndEndRadius: "6px",
    marginRight: "4px",
    height: "40px",
    fontFamily: '"RobotoLight", "Helvetica", "Arial", sans-serif',
    fontSize: "12pt",
    color: "#3e383a",
};

export const buttonStyle = {
    height: "40px",
    width: "40px",
    borderRadius: "6px",
};

export const InputGeneratorContainerStyle = styled.div`
    margin-bottom: 24px;
`;
